import { model as router } from '!/router'
import { F, T } from '@/helpers'
import { createEvent, createStore, sample } from 'effector'
import { NoPaymentChannel } from '~/features/payment/interfaces'
import {
  $isAnyPaymentPopupOpened,
  closePaymentPopupWithType,
  openPaymentPopupWithType,
} from './model'

export const openNoOptionsPopup = createEvent()
export const closeNoOptionsPopup = createEvent()

export const $noOptionsPopupIsOpened = createStore<boolean>(false)
  .on(openNoOptionsPopup, T)
  .on(closeNoOptionsPopup, F)
  .on(router.$pathname, F)

sample({
  clock: $noOptionsPopupIsOpened,
  target: $isAnyPaymentPopupOpened,
})

sample({
  clock: openPaymentPopupWithType,
  filter: (type) => type === NoPaymentChannel,
  target: openNoOptionsPopup,
})

sample({
  clock: closePaymentPopupWithType,
  filter: (type) => type === NoPaymentChannel,
  target: closeNoOptionsPopup,
})
